import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Layout from '../../components/Layout';
import { Popup } from '../../components/Popup';
import AudioButton from '../../components/AudioButton';
import $ from "jquery";

import '../../assets/scss/challenge.scss';

const Detail = (props) => {
  const [searchParams] = useSearchParams();
  const id = searchParams.get('id');
  const navigate = useNavigate();

  const [log, setLog] = useState(null);
  const [details, setDetails] = useState([]);
  const [filter, setFilter] = useState('all');
  const [isFloatingActive, setIsFloatingActive] = useState(false);
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  useEffect(() => {
    if (id) fetchDetail();
  }, [id]);

  const fetchDetail = async () => {
    try {
      const response = await axios.get(`/api/challenge/results/${id}`);
      setLog(response.data);
      let parsedDetails = response.data.details;
      if (typeof parsedDetails === 'string') {
        try { parsedDetails = JSON.parse(parsedDetails); } catch (e) { }
      }
      setDetails(parsedDetails || []);
    } catch (err) {
      console.error(err);
    }
  };

  const handleDelete = async () => {
    if (window.confirm('챌린지 결과를 삭제하시겠습니까?')) {
      try {
        await axios.delete(`/api/challenge/results/${id}`);
        navigate('/Challenge/Result');
      } catch (err) {
        console.error(err);
        alert('삭제 실패했습니다.');
      }
    }
  };

  const handleReview = () => {
    const wrongDetails = details.filter(item => !item.is_correct);
    if (wrongDetails.length === 0) {
      alert('틀린 단어가 없습니다!');
      return;
    }
    navigate('/Challenge/View?review=true', { state: { reviewWords: wrongDetails, review: true } });
  };

  const handleRetry = () => {
    if (log && log.chapter) {
      navigate(`/Challenge/View?chapter=${log.chapter}`);
    } else {
      navigate('/Challenge');
    }
  };

  if (!log) return <Layout containName='result'>Loading...</Layout>;

  const filteredDetails = details.filter(item => {
    if (filter === 'correct') return item.is_correct;
    if (filter === 'wrong') return !item.is_correct;
    return true;
  });

  return (
    <Layout header={{ title: '상세 결과', Backbtn: true, link: '/Challenge/Result' }} containName='result'>

      <div className="select-wrap">
        <div className={`select ${isFilterOpen ? 'active' : ''}`}>
          <button type="button" onClick={() => setIsFilterOpen(!isFilterOpen)}>
            {filter === 'all' ? '전체' : (filter === 'correct' ? '정답만' : '오답만')}
          </button>
          <ul style={{ display: isFilterOpen ? 'block' : 'none' }}>
            <li className={filter === 'all' ? 'active' : ''} onClick={() => { setFilter('all'); setIsFilterOpen(false); }}>전체</li>
            <li className={filter === 'correct' ? 'active' : ''} onClick={() => { setFilter('correct'); setIsFilterOpen(false); }}>정답만</li>
            <li className={filter === 'wrong' ? 'active' : ''} onClick={() => { setFilter('wrong'); setIsFilterOpen(false); }}>오답만</li>
          </ul>
        </div>
      </div>

      <ul className="result-view" style={{ paddingBottom: '100px' }}>
        {filteredDetails.map((item, idx) => {
          // Check if user input is redundant (matches meaning)
          const isRedundant = item.user_input && (item.user_input.trim() === item.meaning.trim());

          return (
            <li key={idx} style={{ display: 'flex', alignItems: 'flex-start', borderBottom: '1px solid #f0f0f0', padding: '15px 0' }}>
              <div style={{ flex: 1 }}>
                <div style={{ display: 'flex', alignItems: 'baseline', gap: '15px' }}>
                  <span style={{ fontSize: '18px', fontWeight: '800', color: '#171717', width: '130px', letterSpacing: '-0.5px' }}>
                    {item.word}
                  </span>
                  <span style={{ fontSize: '15px', color: '#686868', fontWeight: '400' }}>
                    {item.meaning}
                  </span>
                </div>
                {item.user_input && !isRedundant && (
                  <div style={{
                    marginTop: '2px',
                    fontSize: '13px',
                    fontWeight: '400',
                    color: item.is_correct ? '#999' : '#ff4d4d',
                  }}>
                    {item.user_input}
                  </div>
                )}
              </div>
              <button type="button" className="btn-sound"><AudioButton word={item.word} /></button>
            </li>
          );
        })}
      </ul>

      {/* Floating Button Menu */}
      <div className={`floating-wrap ${isFloatingActive ? 'active' : ''}`} style={{
        zIndex: 100,
        pointerEvents: isFloatingActive ? 'auto' : 'none'
      }}>
        <div className="dim-layer"
          onClick={() => setIsFloatingActive(false)}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(0,0,0,0.3)',
            opacity: isFloatingActive ? 1 : 0,
            transition: 'opacity 0.3s ease',
            pointerEvents: isFloatingActive ? 'auto' : 'none'
          }}
        ></div>

        <ul className="btn-list" style={{
          position: 'absolute',
          right: '0px',
          bottom: '40px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '12px',
          listStyle: 'none',
          margin: 0,
          padding: 0,
          opacity: isFloatingActive ? 1 : 0,
          transform: isFloatingActive ? 'translateY(0)' : 'translateY(20px)',
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          zIndex: 102
        }}>
          <li style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', width: '250px' }}>
            <span className="label" style={{
              marginRight: '12px',
              color: '#fff',
              fontSize: '15px',
              fontWeight: '700',
              textAlign: 'right'
            }}>챌린지 재 도전</span>
            <button type="button" className="btn-retry" onClick={handleRetry} style={{
              position: 'relative',
              width: '42px',
              height: '42px',
              borderRadius: '50%',
              background: '#FF7043',
              border: 'none',
              boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
              cursor: 'pointer'
            }}></button>
          </li>
          <li style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', width: '250px' }}>
            <span className="label" style={{
              marginRight: '12px',
              color: '#fff',
              fontSize: '15px',
              fontWeight: '700',
              textAlign: 'right'
            }}>단어복습</span>
            <button type="button" className="btn-revise" onClick={handleReview} style={{
              position: 'relative',
              width: '42px',
              height: '42px',
              borderRadius: '50%',
              background: '#FF7043',
              border: 'none',
              boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
              cursor: 'pointer'
            }}></button>
          </li>
          <li style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', width: '250px' }}>
            <span className="label" style={{
              marginRight: '12px',
              color: '#fff',
              fontSize: '15px',
              fontWeight: '700',
              textAlign: 'right'
            }}>삭제</span>
            <button type="button" className="btn-cancel" onClick={handleDelete} style={{
              position: 'relative',
              width: '42px',
              height: '42px',
              borderRadius: '50%',
              background: '#FF7043',
              border: 'none',
              boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
              cursor: 'pointer'
            }}></button>
          </li>
        </ul>

        {/* Placing the button inside the constrained fixed wrapper */}
        <button type="button"
          className={`open-floating ${isFloatingActive ? 'active' : ''}`}
          onClick={() => setIsFloatingActive(!isFloatingActive)}
          style={{
            position: 'absolute',
            right: '20px',
            bottom: '20px',
            width: '52px',
            height: '52px',
            borderRadius: '50%',
            background: '#FF7043',
            color: '#fff',
            border: 'none',
            boxShadow: '0 4px 15px rgba(255, 112, 67, 0.4)',
            zIndex: 103,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
            transform: isFloatingActive ? 'rotate(45deg)' : 'rotate(0)',
            pointerEvents: 'auto'
          }}
        ></button>
      </div>

    </Layout>
  );
};

export default Detail;